import { css } from '@emotion/react';
import { faMessageSmile } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons/roundButton/roundButton.component';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import { type Theme } from '~/_shared/themes/theme.model';
import { useIntercom } from '~/_shared/utils/3rdPartyIntegrations/intercom/intercom.context';
import {
  MAPS_ATTRIBUTION_BAR_BOTTOM_OFFSET_PX, RIGHT_SIDE_RIGHT_OFFSET_PX,
} from '~/map/mapToolControls/mapOffsets.constants';

const SHADOW_OFFSET = 3;

const chatButtonWrapperStyle = (theme: Theme) => css({
  borderRadius: '50%',
  bottom: MAPS_ATTRIBUTION_BAR_BOTTOM_OFFSET_PX,
  boxShadow: `0px 2px 15px ${theme.shadowColors.primary}`,
  position: 'absolute',
  right: RIGHT_SIDE_RIGHT_OFFSET_PX + SHADOW_OFFSET,
  zIndex: 1,
});

export const ChatButtonComponent: FC = () => {
  const { isBooted, show: showIntercom } = useIntercom();

  return (
    <div css={chatButtonWrapperStyle}>
      <RoundButtonComponent
        buttonStyle={isBooted ? RoundButtonStyle.Disabled : RoundButtonStyle.Quaternary}
        icon={faMessageSmile}
        isDisabled={!isBooted}
        onClick={showIntercom}
        size={RoundButtonSize.XLarge}
      />
    </div>
  );
};
